import React from "react";
import { Outlet } from "react-router-dom";

const Clinics = () => {
  return <Outlet />;
};

export default Clinics;
